/* eslint-disable operator-linebreak */
import React, { useMemo, useState } from 'react'
import { Row, Col, Glyphicon } from 'react-bootstrap'
import axios from 'axios'
import { useT } from '@transifex/react'

import { swalError, swalSuccess } from '../../../common/components/Swaler'
import NewUserCompany from '../../Modals/NewUserCompany'
import '../../Lock/css/lock.css'
import translationMappings from '../../../transifex/translationMappings'
import HandleStorageSupplierClientsModal from '../../Modals/HandleStorageSupplierClientsModal'

const PendingAccessRequestUserItem = ({ titleStyle, isMobile, accessRequest: { lock, customer }, finishRequest }) => {
  const [selectedCompany, setSelectedCompany] = useState()
  const [lockPermissions, setLockPermissions] = useState([])
  const [isHandleStorageSupplierClientsModalOpen, setIsHandleStorageSupplierClientsModalOpen] = useState('')
  const [storageSuppliers, setStorageSuppliers] = useState(null)
  const t = useT()

  const handleAccessRequest = (isApproved) =>
    fetch(`${window.MYQLOCX_API}/subject/admin/locks/${lock._id}/accessrequests`, {
      method: 'PUT',
      headers: { ...axios.defaults.headers.common, 'Content-Type': 'application/json' },
      body: JSON.stringify({ isApproved, customerId: customer._id, selectedCompany: selectedCompany.value, lockPermissions }),
    })
      .then((r) => r.json())
      .then((r) => {
        if (r.message === 'Customer number of company required') {
          setIsHandleStorageSupplierClientsModalOpen(true)
          setStorageSuppliers(r.suppliers)
        } else {
          swalSuccess('Sparat!', '', 'OK')
          finishRequest(customer)
        }
      })
      .catch((e) => {
        console.log(e)
      })

  const submitNewSuppliers = async (suppliers) => {
    setIsHandleStorageSupplierClientsModalOpen(false)
    axios.put(`${window.MYQLOCX_API}/subject/admin/locks/storage/suppliers`, { locks: [lock._id], suppliers })
  }

  const permissionIsToggled = (permission) => lockPermissions && lockPermissions.includes(permission)
  const togglePermission = (permission) => {
    setLockPermissions((prevLockPermissions) => {
      if (prevLockPermissions && prevLockPermissions.includes(permission)) {
        return prevLockPermissions.filter((p) => p !== permission)
      }
      return [...(prevLockPermissions || []), permission]
    })
  }
  const permissionsToShow = useMemo(() => {
    const permissions = ['contactPerson']
    if (lock.type === 'passage' && lock.storage) {
      permissions.push('storageCreateOrder', 'storageModifyInventory')
    }
    if (lock.qiot) {
      permissions.push('remoteAccess')
    }
    if (lock.rentalActive !== false && lock.sub_type === 'container') {
      permissions.push('rental')
    }
    if (lock.carrier_door) {
      permissions.push('carrierDoorAccess')
      if (lock.carrier_door?.qiot) {
        permissions.push('remoteCarrierDoorAccess')
      }
    }
    return permissions
  }, [lock])

  return (
    <Row style={{ width: '100%', display: 'block', margin: 'auto' }} key={customer._id}>
      <ul style={{ borderRadius: 20, marginBottom: '10px', width: '100%', paddingBottom: 10 }} className="lock-list">
        <li className="lock-flex-container">
          <Col xs={12} sm={12} md={2}>
            <div>
              <p style={{ marginTop: 15 }} className="lock-label">
                <span style={titleStyle}>
                  {customer.name ? customer.name : <span style={{ fontWeight: '500' }}>Telefon: </span>} {customer.surname ? customer.surname : ''}
                </span>
              </p>
              <p style={{ marginTop: -10, fontSize: '14px' }}>
                <span>{`${customer.phone || ''} ${customer.email || ''}`}</span>
              </p>
            </div>
          </Col>
          <Col sm={4} md={2}>
            <br />
            <p
              style={{
                fontWeight: 'bold',
              }}
            >
              {lock.custom_name}
            </p>
          </Col>
          <Col sm={4} md={4}>
            <p style={{ fontWeight: 'bold', marginLeft: '25px', marginTop: '10px' }}>{t('Roles')}</p>

            <ul style={{ marginTop: '5px', listStyle: 'none', paddingLeft: '20px' }}>
              {permissionsToShow.map((p) => (
                <li key={p} onClick={() => togglePermission(p)} style={{ textDecoration: 'none', cursor: 'pointer' }}>
                  {t(translationMappings[p])}
                  {permissionIsToggled(p) ? (
                    <Glyphicon glyph="glyphicon glyphicon-check" style={{ color: '#006e78', marginRight: '5px', marginLeft: '5px', float: 'left' }} />
                  ) : (
                    <Glyphicon glyph="glyphicon glyphicon-unchecked" style={{ color: 'grey', marginRight: '5px', marginLeft: '5px', float: 'left' }} />
                  )}
                </li>
              ))}
            </ul>
          </Col>
          <Col sm={4} md={3}>
            <br />
            <NewUserCompany companySelected={setSelectedCompany} />
          </Col>
          <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
            <Col sm={3} md={2}>
              <p
                onClick={() => {
                  if (!selectedCompany || !selectedCompany.value) return swalError(t('Company missing'))
                  handleAccessRequest(true)
                }}
                style={{
                  minHeight: isMobile ? 60 : 0,
                  marginTop: isMobile ? 0 : 18,
                  color: '#FFF',
                  backgroundColor: '#006e78',
                }}
                className="sub-title-text-container"
              >
                <span style={{ marginTop: isMobile ? 10 : 0 }}>{t('Confirm')}</span>
              </p>
            </Col>
            <Col sm={3} md={2}>
              <p
                onClick={() => handleAccessRequest()}
                style={{
                  minHeight: isMobile ? 60 : 0,
                  marginTop: isMobile ? 0 : 18,
                  color: '#FFF',
                  backgroundColor: '#C10000',
                }}
                className="sub-title-text-container"
              >
                <span style={{ marginTop: isMobile ? 10 : 0 }}>{t('Deny')}</span>
              </p>
            </Col>
          </div>
        </li>
      </ul>
      {selectedCompany && (
        <HandleStorageSupplierClientsModal isOpen={isHandleStorageSupplierClientsModalOpen} closeModal={() => setIsHandleStorageSupplierClientsModalOpen(false)} preselectedCompanies={[selectedCompany]} suppliers={storageSuppliers} updateSuppliers={submitNewSuppliers} t={t} />
      )}
    </Row>
  )
}

export default PendingAccessRequestUserItem
